<template>
  <div class="zen-import text-dark">
    <div class="zen-hero-bg"></div>
    <div class="zen-import-container">
      <h1>{{ $t('vue2.zen_import.import_from_zen') }}</h1>
      <div class="box" v-if="isLoading">
        <Loader bgColor="#fff"></Loader>
      </div>
      <template v-else>
        <div class="d-input-group">
          <label class="d-label d-label--white">{{ $t('vue2.zen_import.choose_version') }}</label>
          <h4 class="text-explainer" v-if="schedules.length < 1">
            {{ $t('vue2.zen_import.you_have_no_created_any_versions') }}
          </h4>
          <div class="zen-schedules" v-else>
            <div class="zen-schedule zen-schedule__header">
              <div class="zen-schedule__left"></div>
              <div>
                <label class="d-label">{{ $t('vue2.zen_import.last_updated') }}</label>
              </div>
            </div>
            <div class="zen-schedule"
                 @click="setActiveSchedule(schedule.scheduleUuid)"
                 :key="schedule.scheduleUuid"
                 v-for="schedule in schedules" :class="{'zen-schedule--selected': isSelected(schedule.scheduleUuid)}">
              <div class="zen-schedule__left">
                <div class="d-radio" :class="{'d-radio--selected': isSelected(schedule.scheduleUuid)}"></div>
                <p class="zen-schedule__title">{{ schedule.title }}</p>
              </div>
              <p class="zen-schedule__modified">
              <span class="zen-schedule__modified__date hint--right"
                    :content="showDate(schedule.modifiedAt)"
                    v-tippy="{
                    arrow: true,
                    placement : 'right'
                  }">{{ showHumanizeDate(schedule.modifiedAt) }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="d-input-group">
          <label class="d-label">{{ $t('vue2.zen_import.choose_schoolyear') }}</label>
          <ChangeSchoolYear :whiteTheme="true" style="max-width: 210px;"></ChangeSchoolYear>
        </div>
        <div class="d-input-group">
          <label class="d-label">{{ $t('vue2.zen_import.insert_in_week') }}</label>
          <DatePicker v-model="theDate"
                      :type="datepickerType"
                      :lang="datepickerLang"
                      value-type="YYYY-MM-DD"
                      :format="datepickerFormat">
          </DatePicker>
        </div>
        <div class="d-input-group">
          <button class="bttn bttn--primary bttn--large bttn--primary--disabled" v-if="schedules.length < 1">
            {{ $t('vue2.zen_import.insert_schedules') }}
          </button>
          <button class="bttn bttn--primary bttn--large" v-if="!isSendingData && schedules.length > 0"
                  @click="submitSchudules">{{ $t('vue2.zen_import.insert_schedules') }}
          </button>
          <button class="bttn bttn--primary bttn--large bttn--loading" v-if="isSendingData"></button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import Loader from '../common/Loader'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import Spinner from '../common/Spinner'
import DatePicker from 'vue2-datepicker'

export default {
  components: {Spinner, Loader, ChangeSchoolYear, DatePicker},
  data () {
    return {
      isLoading: false,
      isSendingData: false,
      schedules: [],
      theSelected: null,
      theDate: moment().format('YYYY-MM-DD')
    }
  },
  computed: {
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    datepickerType () {
      return window.SCHOOL.id === 40235 ? 'date' : 'week'
    },
    datepickerLang () {
      return {
        formatLocale: {
          firstDayOfWeek: window.SCHOOL.id === 40235 ? 0 : 1
        }
      }
    },
    datepickerFormat () {
      return window.SCHOOL.id === 40235 ? 'YYYY-MM-DD' : this.$t('vue2.zen_import.week') + ' w, YYYY'
    }
  },
  watch: {
    activeSchoolYear (val) {
      this.theDate = this.activeSchoolYear.student_time_start
    }
  },
  methods: {
    isSelected (id) {
      return this.theSelected === id
    },
    setActiveSchedule (id) {
      this.theSelected = id
    },
    setDate (date) {
      this.theDate = date
    },
    readVersions () {
      this.isLoading = true
      docendo.listImports(window.SCHOOL.id, versions => {
        if (versions.length < 1) {
          this.schedules = []
        } else {
          let sortedVersions = versions.sort((a, b) => {
            let aModified = a.modifiedAt ? a.modifiedAt : moment()
            let bModified = b.modifiedAt ? b.modifiedAt : moment()
            return new Date(bModified) - new Date(aModified)
          })
          this.schedules = sortedVersions
          this.theSelected = sortedVersions[0].scheduleUuid
        }
        this.isLoading = false
      }, failure => {
        console.log('failure', failure)
        this.isLoading = false
      })
    },
    submitSchudules () {
      this.isSendingData = true
      let serverDate = moment(this.theDate).isoWeekday(1).format('YYYY-MM-DD')
      if (window.SCHOOL.id === 40235) {
        serverDate = moment(this.theDate).format('YYYY-MM-DD')
      }
      docendo.enqueueImport(window.SCHOOL.id, this.theSelected, serverDate, this.activeSchoolYear.id, success => {
        eventbus.toast = {
          text: this.$t('vue2.zen_import.schedules_are_being_inserted') + ' ' + moment(this.theDate).isoWeek(),
          success: true
        }
        this.isSendingData = false
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.common.something_went_wrong'), success: false}
        this.isSendingData = false
      })
    },
    showHumanizeDate (date) {
      moment.locale(window.USER.language)
      let diff = moment().diff(moment(date))
      return moment.duration(diff).humanize() + ' ' + this.$t('vue2.common.ago')
    },
    showDate (modifiedAt) {
      moment.locale(window.USER.language)
      return moment(modifiedAt).format('LLLL')
    }
  },
  mounted () {
    this.readVersions()
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';


.zen-import {
  background-color: #ffffff;
  max-width: 750px;
  margin: 20px auto;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.zen-hero-bg {
  position: absolute;
  z-index: 0;
  top: -50px;
  left: 0;
  right: 0;
  width: 100%;
  height: 350px;
  overflow: hidden;
  transform: skewY(
    -12deg
  );
  transform-origin: 0;
  background: #4553ff;
  background: linear-gradient(
    90deg, #4553ff, #7f7fd5);
}

.zen-import-container {
  position: relative;
  z-index: 1;
  padding: 60px;
  border-radius: 4px;
}

.zen-import h1 {
  color: #ffffff;
  margin-bottom: 40px;
}

.d-input-group {
  margin: 2rem 0;
}

.d-input-group .d-label {
  margin-bottom: 0.5rem;
}

.zen-schedule {
  background: #ffffff;
  padding: 0.5rem;
  max-width: 100%;
  min-width: 100%;
  margin-right: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ececf0;
  border-width: 0 1px 1px 1px;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  transition: 0.25s;
}

.zen-schedule:hover {
  background: #f0f5ff;
}

.zen-schedule.zen-schedule__header {
  background-color: #fcfafa;
}

.zen-schedule__left {
  display: flex;
  align-items: center;
}

.zen-schedule:first-child {
  border-radius: 4px 4px 0 0;
}

.zen-schedule:last-child {
  border-radius: 0 0 4px 4px;
}

.zen-schedule.zen-schedule--selected {
  background: #f0f5ff;
}

.zen-schedule .d-checkbox {
  margin-right: 1rem;
}

.zen-schedule__title {
  font-weight: bold;
}
.zen-schedule .d-label {
  margin-bottom: 0;
}

.zen-schedule__modified__date {
  font-size: 0.85rem;
}

.d-input-group .bttn.bttn--primary {
  width: 100%;
}

.d-label.d-label--white {
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// ZenImport.vue?f20ea978